module.exports = __webpack_public_path__ + "static/img/illustratepic_01.f587900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/illustratepic_01.png
// module id = e3Po
// module chunks = 1